/** @jsxImportSource @emotion/react */
'use memo'

import {
  PlayerProvider,
  usePlayerContext,
} from 'src/pages/Player/context/PlayerContext'
import PlayerHighlights from 'src/pages/Player/PlayerHighlights'

interface Props {
  playerId: string
}

const HighlightsInner: React.FC = () => {
  const { state } = usePlayerContext()
  return <PlayerHighlights highlights={state.highlights} />
}

const HighlightsTab: React.FC<Props> = ({ playerId }) => (
  <PlayerProvider playerId={playerId}>
    <HighlightsInner />
  </PlayerProvider>
)

export default HighlightsTab
